"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChunkedFileUploader = exports.SimpleUpload = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
class SimpleUpload {
    constructor(model, fileName) {
        this.model = model;
        this.fileName = fileName;
        this.progressSubject = new rxjs_1.Subject();
        this.progressObservable = this.progressSubject.asObservable();
        this.finishObs = null;
    }
    get progress() {
        return (0, rxjs_1.concat)([0.3], this.progressObservable);
    }
    get finish() {
        return this.finishObs;
    }
    upload(f, name = f.name) {
        this.finishObs = (0, rxjs_1.from)(fetch(this.model.rootPath() + '/' + this.fileName, {
            method: 'post',
            headers: {
                'Authorization': 'Bearer ' + this.model.vasat.token
            },
            body: f
        }).then(r => r.json())).pipe((0, operators_1.map)(p => {
            return { finished: true, error: (p.status && p.status < 400 ? p : null), aborted: false, status: p.status, uploader: this };
        }));
        return this.finishObs;
    }
    abort() {
        throw new Error("Abort not supported");
    }
}
exports.SimpleUpload = SimpleUpload;
class ChunkedFileUploader {
    constructor(model, fileName, chunkSize = 1000000) {
        this.model = model;
        this.fileName = fileName;
        this.chunkSize = chunkSize;
        this._progress = 0;
        this.progressSubject = new rxjs_1.Subject();
        this.progressObservable = this.progressSubject.asObservable();
        this.finishSubject = new rxjs_1.Subject();
        this.finishObs = this.finishSubject.asObservable();
        this.retrysB4Fail = 5;
    }
    get progress() {
        return (0, rxjs_1.concat)([this._progress], this.progressObservable);
    }
    get finish() {
        return this.finishObs;
    }
    abort() {
        this.cnx = true;
    }
    /**
     * <p>Cancels the current XMLHttpRequest.</p>
     */
    cancel() {
        this.cnx = true;
        this.progressSubject.complete();
        if (this.currentXHR)
            this.currentXHR.abort();
    }
    upload(f, name = f.name) {
        this.model.files.equals('name', name).query().subscribe(res => {
            var _a;
            var progress = (_a = res.items[0]) === null || _a === void 0 ? void 0 : _a.progress;
            if (progress && progress.total == f.size) {
                this.chunkSize = progress.chunkSize;
                this.uploadObservable(f, progress.offset + progress.chunkSize, progress.seq + 1);
            }
            else {
                this.uploadObservable(f);
            }
        });
        return this.finishObs;
    }
    uploadObservable(file, startOffset, seqOffset) {
        this.start = startOffset || 0;
        this.loaded = this.start;
        this.total = file.size;
        this._progress = 0;
        var seq = seqOffset || 0;
        var reader = new FileReader();
        var self = this;
        var errorCount = 0;
        var blob = file.slice(self.start, self.loaded + self.chunkSize);
        var RETRYS = this.retrysB4Fail;
        reader.onload = function (e) {
            var xhr = new XMLHttpRequest();
            self.currentXHR = xhr;
            var upload = xhr.upload;
            upload.addEventListener("progress", function (evt) {
                if (evt.lengthComputable) {
                    self._progress = ((self.loaded + evt.loaded) / self.total);
                    self.progressSubject.next(self._progress);
                }
            }, false);
            xhr.onreadystatechange = function () {
                if (xhr.readyState == 4) {
                    if (self.cnx) {
                        self.finishSubject.next({ finished: false, error: null, aborted: true, uploader: self });
                        self.wrapUp();
                        return;
                    }
                    if (!xhr.responseText || xhr.responseText == '') {
                        errorCount++;
                        if (errorCount >= RETRYS) {
                            self.finishSubject.next({ finished: false, error: { message: xhr.statusText, code: xhr.status }, aborted: false, uploader: self });
                            self.wrapUp();
                        }
                        else {
                            console.log('Network error, trying again in 2 seconds');
                            setTimeout(() => reader.readAsArrayBuffer(blob), 2000);
                        }
                        return;
                    }
                    var res = JSON.parse(xhr.responseText);
                    if (res.status && res.status < 400) {
                        errorCount = 0;
                        self.loaded += self.chunkSize;
                        if (self.loaded <= self.total) {
                            self._progress = (self.loaded / self.total);
                            self.progressSubject.next(self._progress);
                            blob = file.slice(self.loaded, self.loaded + self.chunkSize);
                            reader.readAsArrayBuffer(blob);
                        }
                        else {
                            self._progress = 1;
                            self.progressSubject.next(1);
                            self.loaded = self.total;
                            self.finishSubject.next({ finished: true, error: null, aborted: true, uploader: self, status: res.status });
                            self.finishSubject.complete();
                        }
                    }
                    else {
                        self.finishSubject.error({ finished: false, error: res, aborted: false, chunk: self });
                        self.wrapUp();
                        // TODO Make subject throw error
                        //finishSubject.next({finished:false,error:res,aborted:false,chunk:self})
                    }
                }
            };
            var url = self.model.rootPath() + '/' + self.fileName;
            var stepToUse = self.loaded + self.chunkSize > self.total ? self.total - self.loaded : self.chunkSize;
            xhr.open("POST", url + "?seq=" + seq + "&offset=" + self.loaded + "&length=" + self.total + "&chunk=" + stepToUse);
            seq++;
            xhr.overrideMimeType("application/octet-stream");
            xhr.setRequestHeader('Content-Type', 'application/octet-stream');
            xhr.setRequestHeader('Authorization', 'Bearer ' + self.model.vasat.token);
            xhr.send(e.target.result);
        };
        reader.readAsArrayBuffer(blob);
        return this.finishObs;
    }
    wrapUp() {
        this.finishSubject.complete();
        this.progressSubject.complete();
    }
}
exports.ChunkedFileUploader = ChunkedFileUploader;
